import { nameValidationPattern } from "@cuauth/user-input-validation-rules";

import { DEFAULT_LOCALE, getMessages, type ValidationMessages } from "@/i18n";

import type { ValidationResult } from "./types";

export const NAME_MAX_LENGTH = 30;

export type NameField = "firstName" | "lastName";

export function validateName(
  value: string,
  field: NameField,
  validationMessages: ValidationMessages = getMessages(DEFAULT_LOCALE)
    .validation,
): ValidationResult {
  const trimmedValue = value.trim();

  if (!trimmedValue) {
    return field === "firstName"
      ? validationMessages.firstNameRequired
      : validationMessages.lastNameRequired;
  }

  if (trimmedValue.length > NAME_MAX_LENGTH) {
    return field === "firstName"
      ? validationMessages.firstNameTooLong
      : validationMessages.lastNameTooLong;
  }

  if (!nameValidationPattern.test(trimmedValue)) {
    return field === "firstName"
      ? validationMessages.firstNameInvalidFormat
      : validationMessages.lastNameInvalidFormat;
  }

  return true;
}
